<app-main-menu title="Collections"></app-main-menu>

<div class="content mat-elevation-z8">
  <h1>Alle Collections</h1>

  <mat-form-field style="width:100%">
    <mat-label>Suchen</mat-label>
    <input matInput placeholder="Suche" [(ngModel)]="searchTerm" (input)="searchCollection($event)">
  </mat-form-field>

  <mat-list>
    <mat-list-item *ngFor="let collection of paginatedCollections" class="collection-list-item">
      <img matListItemIcon [src]="collectionImgPath(collection)">
      <span matListItemTitle>{{ collection.designation }}
        <p class="mat-list-item-content-right">
          <button mat-stroked-button color="warn" style="margin-right: 10px;" (click)="deleteCollection(collection.id)">
            Löschen
          </button>
          <button mat-raised-button color="accent" routerLink="/collections/{{ collection.id }}">
            Edit
          </button>
          <!-- <button mat-raised-button color="warn">
            Löschen
          </button> -->
        </p>
      </span>
      <p matListItemLine>
        {{ collection.description }}
      </p>
    </mat-list-item>
  </mat-list>

  <mat-paginator
    (page)="handlePageEvent($event)"
    [length]="collections.length"
    [pageSize]="10"
    [pageSizeOptions]="[5, 10, 25, 100]">
  </mat-paginator>


  <button mat-button routerLink="/collections/-1">
    <mat-icon>add_box</mat-icon>
    Collection hinzufügen
  </button>
</div>
